import { render, staticRenderFns } from "./chat-picture-paster.vue?vue&type=template&id=81d8aed0&scoped=true"
import script from "./chat-picture-paster.vue?vue&type=script&lang=js"
export * from "./chat-picture-paster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d8aed0",
  null
  
)

export default component.exports